import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/Solutions_FMP.png")